import { AnalyticsProvider } from './../providers/analytics-provider.interface';
// analytics.token.ts
import { InjectionToken } from '@angular/core';

export const ANALYTICS_PROVIDERS =
    new InjectionToken<AnalyticsProvider[]>('ANALYTICS_PROVIDERS');
